var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2527 2.978C20.3133 2.11941 22.3806 4.18663 21.522 6.24723L15.5985 20.4637C14.44 23.2439 10.3652 22.774 9.87005 19.803L9.13103 15.3689L4.69695 14.6299C1.72596 14.1348 1.25603 10.06 4.0363 8.90151L18.2527 2.978ZM19.6758 5.478C19.8475 5.06588 19.4341 4.65243 19.022 4.82415L4.80553 10.7477C3.87877 11.1338 4.03542 12.4921 5.02575 12.6571L9.45983 13.3962C10.3028 13.5366 10.9633 14.1972 11.1038 15.0401L11.8428 19.4742C12.0079 20.4646 13.3662 20.6212 13.7523 19.6944L19.6758 5.478Z",
    fill: "#B1B5C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/Line.2b8e313809772eb64942dd7332511f6c.svg";
export { ForwardRef as ReactComponent };